import React from 'react';
import { Stepper, Step, StepLabel } from '@mui/material';
import MediaQuery from 'react-responsive';
import { injectIntl } from 'react-intl';

export class ResponsiveStepper extends React.Component {
  render() {
    const { steps, activeStep, intl } = this.props;

    return (
      <React.Fragment>
        <MediaQuery maxWidth={767}>
          <Stepper activeStep={activeStep} orientation='vertical' style={{backgroundColor: window.BACKGROUND_COLOUR, padding: 24}}>
            {steps.map(label => (
              <Step key={label.key} className="checkout-step">
                <StepLabel>
                  {intl.formatMessage({id: label.key, defaultMessage: label.title_en})}
                </StepLabel>
            </Step>
            ))}
          </Stepper>
        </MediaQuery>

        <MediaQuery minWidth={767}>
          <div style={{width: '90%'}}>
            <Stepper activeStep={activeStep} style={{backgroundColor: window.BACKGROUND_COLOUR, padding: 24}}>
              {steps.map(label => (
                <Step key={label.key} className="checkout-step">
                  <StepLabel>
                    {intl.formatMessage({id: label.key, defaultMessage: label.title_en})}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </div>
        </MediaQuery>
      </React.Fragment>
    );
  }
}

export default injectIntl(ResponsiveStepper);
